import { useFormContext } from '../context/FormContext';

export function StepIndicatorEnhanced() {
  const { form, formService, scrollService, stateService, forceUpdate } = useFormContext();

  const setActiveStep = (stepId: string) => {
    const step = form.steps.find((s) => s.id === stepId);
    if (!step) {
      return;
    }

    const targetStepIndex = formService.getStepIndex(step);
    const activeStep = formService.getActiveStep();
    const activeStepIndex = activeStep ? formService.getStepIndex(activeStep) : 0;

    if (targetStepIndex < activeStepIndex) {
      stateService.showErrors = false;
      formService.setActiveStep(step);
      scrollService.stepScrollToTop();
      forceUpdate();
    }
  };

  const isStepReachable = (stepId: string) => {
    const step = form.steps.find((s) => s.id === stepId);
    const activeStep = formService.getActiveStep();
    if (!step || !activeStep) {
      return false;
    }
    return formService.getStepIndex(step) < formService.getStepIndex(activeStep);
  };

  const isStepComplete = (stepId: string) => {
    const step = form.steps.find((s) => s.id === stepId);
    const activeStep = formService.getActiveStep();
    if (!step || !activeStep) {
      return false;
    }
    return formService.getStepIndex(activeStep) > formService.getStepIndex(step);
  };

  return (
    <div className="notify-step-indicator stepform-step-indicator">
      <ul className="step-indicator-container">
        {form.steps.map((step, index) => (
          <li key={step.id} className={`step-indicator-step-${index}`}>
            <button
              type="button"
              className={`${formService.isActiveStep(step) ? 'current' : ''}${isStepComplete(step.id) ? ' checked' : ''}`}
              disabled={!formService.isActiveStep(step) && !isStepReachable(step.id)}
              onClick={() => setActiveStep(step.id)}
            >
              <span
                className={`notify-step-indicator__index${isStepComplete(step.id) ? ' notify-step-indicator__index--checked' : ''}`}
              >
                {index + 1}
              </span>
              <span
                className="notify-step-indicator__label"
                dangerouslySetInnerHTML={{ __html: step.navigationLabel }}
              />
            </button>
          </li>
        ))}
      </ul>
    </div>
  );
}
